import type { SendChannel } from '@/services/notificationService'
import { channelKind } from './channelKinds'
import type { ChannelDrafts } from './sendContent'

export type TemplateText = { subject?: string; body: string }

export type MessageTemplate = {
  id: string
  name: string
  channels: {
    whatsapp?: TemplateText
    sms?: TemplateText
    email?: TemplateText
  }
}

// The "תבנית הודעה" list is fixed for now. The dropdown stays hidden while it
// is empty. Add entries here and nowhere else.
export const MESSAGE_TEMPLATES: MessageTemplate[] = []

/** Fills the ticked panels that the template has text for. Other drafts stay. */
export const applyTemplate = (
  template: MessageTemplate,
  channels: SendChannel[],
  tickedIds: number[],
  drafts: ChannelDrafts
): ChannelDrafts => {
  const next = { ...drafts }
  for (const channel of channels) {
    if (!tickedIds.includes(channel.channelId)) continue
    const kind = channelKind(channel)
    if (kind === 'other') continue
    const text = template.channels[kind]
    if (text)
      next[channel.channelId] = { body: text.body, subject: text.subject ?? '' }
  }
  return next
}
